import "../style/css/FloatingDiv.css"
import {motion} from "framer-motion"


function FloatingDiv({img}) {
  return (
    <div 

    className="floating-div">
      <motion.img 
          transition={{
            duration: 2
          }}
          initial={{
            opacity: 0
          }}
          whileInView={{
            opacity: 1
          }}
      src={img} alt="" style={{width: "100%", height: '100%'}}/>
    </div>
  )
}

export default FloatingDiv